import ApiService from "../../../services/ApiService";

const GuardianService = {
    // Parent genre mapping
    PARENT_GENRES: {
        "0449e53d-bbb5-400f-965c-967594024c62": "News",
        "d77a16bc-322d-42a4-9d95-5bbe5031d94e": "Entertainment", 
        "e08eb90a-6605-4d53-a4f3-16b60ca6c15d": "Education and Learning",
        "727cc86f-06d7-480e-a635-baffebfd7ccd": "Technology",
        "7a095394-1432-4d25-bc0a-ddf7ebdd5c99": "Business",
        "f3f56e0f-682c-4d18-af85-1a4f8f1a620a": "Politics",
        "c409319c-5a52-4300-9d01-431f2ab43955": "Science",
        "e4f4ef71-d93b-454b-9f8b-a16104814714": "Sport",
        "7a57bc05-5a60-4a20-9b83-11f4267850a2": "Lifestyle and Culture"
    },

    getAllSections: async () => {
        try {
            const response = await fetch('https://content.guardianapis.com/sections?api-key=0c98f86f-328d-40ae-8761-c46c3bd398a7');
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data.response && data.response.results) {
                return {
                    success: true,
                    data: data.response.results,
                    total: data.response.total
                };
            } else {
                throw new Error('Invalid response format');
            }
        } catch (error) {
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Map Guardian section to appropriate parent genre
    mapSectionToGenre: (sectionId, sectionTitle) => {
        const lowerTitle = sectionTitle.toLowerCase();
        const lowerId = sectionId.toLowerCase();

        // News categories
        if (lowerId.includes('news') || lowerId.includes('world') || lowerId.includes('uk-') || lowerId.includes('us-') || lowerId.includes('australia-')) {
            return "0449e53d-bbb5-400f-965c-967594024c62"; // News
        }

        // Entertainment
        if (lowerId.includes('culture') || lowerId.includes('film') || lowerId.includes('music') || lowerId.includes('tv') || 
            lowerId.includes('books') || lowerId.includes('artanddesign') || lowerId.includes('games') || 
            lowerTitle.includes('television') || lowerTitle.includes('radio')) {
            return "d77a16bc-322d-42a4-9d95-5bbe5031d94e"; // Entertainment
        }

        // Education and Learning
        if (lowerId.includes('education') || lowerId.includes('universities') || lowerId.includes('students') ||
            lowerId.includes('childrens-books') || lowerId.includes('teacher') || lowerId.includes('higher-education')) {
            return "e08eb90a-6605-4d53-a4f3-16b60ca6c15d"; // Education and Learning
        }

        // Technology
        if (lowerId.includes('technology') || lowerId.includes('tech') || lowerId.includes('digital') || 
            lowerId.includes('science') || lowerId.includes('environment')) {
            return "727cc86f-06d7-480e-a635-baffebfd7ccd"; // Technology
        }

        // Business
        if (lowerId.includes('business') || lowerId.includes('money') || lowerId.includes('economics') || 
            lowerId.includes('work') || lowerId.includes('careers') || lowerId.includes('better-business')) {
            return "7a095394-1432-4d25-bc0a-ddf7ebdd5c99"; // Business
        }

        // Politics
        if (lowerId.includes('politics') || lowerId.includes('government') || lowerId.includes('law') || 
            lowerId.includes('public') || lowerId.includes('global-development')) {
            return "f3f56e0f-682c-4d18-af85-1a4f8f1a620a"; // Politics
        }

        // Science (if not already caught by Technology)
        if (lowerId.includes('science') || lowerId.includes('research') || lowerId.includes('medical') || 
            lowerId.includes('health') || lowerId.includes('environment')) {
            return "c409319c-5a52-4300-9d01-431f2ab43955"; // Science
        }

        // Sport
        if (lowerId.includes('sport') || lowerId.includes('football') || lowerId.includes('cricket') || 
            lowerId.includes('tennis') || lowerId.includes('rugby') || lowerId.includes('olympics')) {
            return "e4f4ef71-d93b-454b-9f8b-a16104814714"; // Sport
        }

        // Lifestyle and Culture (default for most other categories)
        return "7a57bc05-5a60-4a20-9b83-11f4267850a2"; // Lifestyle and Culture
    },

    migrateSections: async (sections) => {
        try {
            const results = [];
            let successCount = 0;
            let errorCount = 0;

            for (let i = 0; i < sections.length; i++) {
                const section = sections[i];
                const parentId = GuardianService.mapSectionToGenre(section.id, section.webTitle);
                
                const genreData = {
                    name: section.webTitle,
                    displayOrder: i + 1,
                    description: `Guardian section: ${section.webTitle}`,
                    active: true,
                    parentId: parentId,
                    guardianId: section.id
                };

                try {
                    const result = await ApiService.postData("/v1/genre", genreData);
                    results.push({
                        section: section.webTitle,
                        status: 'success',
                        data: result
                    });
                    successCount++;
                } catch (error) {
                    results.push({
                        section: section.webTitle,
                        status: 'error',
                        error: error.message
                    });
                    errorCount++;
                }
            }

            return {
                success: true,
                results: results,
                summary: {
                    total: sections.length,
                    successful: successCount,
                    failed: errorCount
                }
            };
        } catch (error) {
            return {
                success: false,
                error: error.message
            };
        }
    }
};

export default GuardianService;
